import React from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import { LiaShoppingBagSolid } from "react-icons/lia";

const Wrapper = styled.div`
  margin: 100px 0;
`;

const Header = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
`;

const Description = styled.p`
  max-width: 300px;
  text-align: center;
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
`;

function ExclusivesSection() {
  return (
    <Wrapper>
      <Header> 
        <LiaShoppingBagSolid size={40} />
        <Description>
          You have no active offers at this time
        </Description>
      </Header>
    </Wrapper>
  );
}

export default ExclusivesSection;
